import { jsx as b } from "react/jsx-runtime";
import L from "classnames";
import { useMemo as o } from "react";
import n from "./index.es5644.js";
import { Label as c } from "./index.es61.js";
const P = ({
  value: s,
  formatValue: p,
  testId: r = "label-cell",
  color: a = "blue",
  textToLabelColor: m,
  gridDensity: d,
  colDef: t
}) => {
  const C = L(n.labelCellRoot, n[d]), e = o(
    () => {
      var i;
      return (i = t == null ? void 0 : t.customCellGlobalProps) == null ? void 0 : i.textToLabelColor;
    },
    [t == null ? void 0 : t.customCellGlobalProps]
  ), l = o(
    () => m ?? e,
    [e, m]
  ), u = o(
    () => (l == null ? void 0 : l[s]) ?? a,
    [a, s, l]
  );
  return /* @__PURE__ */ b("div", { className: C, "data-testid": r, children: /* @__PURE__ */ b(c, { color: u, testId: r + "-label", children: p }) });
};
export {
  P as LabelCell
};
//# sourceMappingURL=index.es626.js.map
